const todoItems = {
  checkAll: 'Вибрати все',
  createTodoList: 'Створити список завдань',
  editTodoList: 'Редагувати список завдань',
  plural: 'Список завдань',
  uncheckAll: 'Зняти все',
  enterListTitle: 'Введіть назву списку',
  extractToDoItemsFromWhiteboard: 'Витягти елементи списку з вайтборду',
  confirmCloseWithoutSavingMessage:
    'Після закриття дані не будуть збережені. Ви впевнені, що хочете вийти?'
};

export default todoItems;
